import { createRef } from 'react';

export const scrollRef = createRef();
